import type { ChatMessage } from "~/pages/appointments/hooks/useAgentChat";

/**
 * The suggestion to offer as ghost text: only while the reply that carries it
 * is still the last message, i.e. the user has not answered it. Read from the
 * message list alone, so a reload (history sorted by `createdAt`) gives the
 * same answer, and an answered reply's suggestion never comes back. Never
 * falls back to an older reply's. A stopped reply offers nothing: the model
 * never finished deciding what comes next.
 */
export function composerSuggestion(messages: ChatMessage[]): string | null {
  const last = messages.at(-1);
  if (!last || last.role !== "assistant" || last.stopped) return null;
  return last.suggestedUserPrompt?.trim() || null;
}
